import { Space } from '@arco-design/web-react';
import {
  IconFullscreen,
  IconFullscreenExit,
} from '@arco-design/web-react/icon';
import dayjs from 'dayjs';
import React from 'react';
import { pxToRem } from '../util';
import Logo from '@/assets/screen_logo.png';
const Header = () => {
  const color = 'rgb(206, 234, 255)';
  // 写一个当前时间的函数，一直更新
  const [currentTime, setCurrentTime] = React.useState(new Date());
  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  //   检查当前是否处于全屏状态，如果是，则退出全屏；如果不是，则进入全屏
  const isFullscreen = () => {
    return document.fullscreenElement != null;
  };
  const handleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px',
        boxSizing: 'border-box',
        height: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 10,
          fontFamily: '阿里妈妈数黑体 Bold',
        }}
      >
        <div
          style={{
            height: pxToRem(50),
            width: pxToRem(50),
            // background: '#fff',
          }}
        >
          <img
            src={Logo}
            alt="logo"
            style={{ width: '100%', height: '100%' }}
          />
        </div>
        <div
          style={{ fontSize: pxToRem(40), color: 'white', fontWeight: 'bold' }}
        >
          健康数据大屏
        </div>
      </div>
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            fontFamily: '阿里妈妈数黑体 Bold',
            gap: 20,
          }}
        >
          <div
            style={{
              color: color,
              fontSize: pxToRem(24),
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            <div style={{ marginBottom: -3 }}>
              {dayjs(currentTime).format(' HH:mm:ss')}
            </div>
            <div style={{ fontSize: pxToRem(14) }}>
              {dayjs(currentTime).format('YYYY-MM-DD')}
            </div>
          </div>
          {/* 全屏按钮（ICON） */}
          {isFullscreen() ? (
            <div style={{ cursor: 'pointer' }}>
              <IconFullscreenExit
                onClick={handleFullscreen}
                style={{ color: color, fontSize: pxToRem(26) }}
              />
            </div>
          ) : (
            <div style={{ cursor: 'pointer' }}>
              <IconFullscreen
                onClick={handleFullscreen}
                style={{ color: color, fontSize: pxToRem(26) }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Header;
